class Utils {
  static settings = {
    hideClass: "hide",
    defaultBgColor: "#000",
    header: document.querySelector(".header"),
    headerWrapper: document.querySelector(".header-wrapper"),
  };

  constructor() {
    if (Utils.instance) {
      return Utils.instance;
    }
    Utils.instance = this;
    this.settings = Utils.settings;
    this.init();
  }

  init() {
    this.initDataTriggerHandler();
    this.initSmoothScroll();
    this.initTooltips();
    this.initHeightEqualizer();
    this.extendEventTargetPrototype();
    this.initFeatureScripts();

    document.querySelectorAll('details.mega-menu').forEach((details) => {
      let hoverTimeout;

      details.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        details.setAttribute('open', 'true');
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(() => {
          details.removeAttribute('open');
          details.querySelector('summary').setAttribute('aria-expanded', 'false');
        }, 150);
      });

      // details.querySelector('summary').addEventListener('click', (e) => {
      //   e.preventDefault();
      // });
    });
  }

  /*/__________________________________________________________________________________
  : Initializes all additional feature scripts.
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initFeatureScripts() {
    this.initStickyButtonHandler();
    this.initProductBundles();
    this.initProductCardVariantHandler();
    this.mobileSearchTrigger();
    this.initProductCardButtonHandler();
  }

  mobileSearchTrigger() {
    const header = this.settings.header;
    const headerWrapper = this.settings.headerWrapper;

    document.delegateListener("click", `body`, function (e) {
      if(e.target.classList.contains("header__searchbar")) {
        header.classList.remove("style--searchOpen");
        headerWrapper.classList.remove("header-wrapper--border-bottom");
      }
    });

    document.delegateListener("click", `[data-element="mobile-search-trigger"]`, function (e) {
      const sidebar = document.querySelector(`[data-snippet="mobile-sidebar"]`);
      if(sidebar.classList.contains("overlay--active")) {
        sidebar.classList.remove("overlay--in-transition");
        document.querySelector("body").setAttribute("data-overflow", "true");

        setTimeout(() => {
          sidebar.classList.remove("overlay--active");
        }, 200);
        
        header.classList.add("style--searchOpen");
      } else {
        header.classList.toggle("style--searchOpen");
      }

      document.getElementById('Search-In-Modal').focus();

      headerWrapper.classList.toggle("header-wrapper--border-bottom");
    });
  }

  initProductCardVariantHandler() {
    const cache = {};
    document.delegateListener("click", "button[data-url]", async function (e) {
      const button = this;
      const url = button.dataset.url;
      const card = button.closest(".grid__item") || button.closest(".slide--inner");
      const contentWrapper = card;
      const allButtons = card.querySelectorAll("button[data-url]");

      allButtons.forEach((btn) => btn.classList.remove("style--selected"));
      button.classList.add("style--selected");

      if (cache[url]) {
        contentWrapper.innerHTML = cache[url];
        return;
      }
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Network response was not ok");

        const html = await res.text();
        cache[url] = html;
        
      // console.log("initProductCardVariantHandler", url, contentWrapper, html);
        contentWrapper.innerHTML = html;
      } catch (err) {
        console.error("Variant fetch failed:", err);
      }
    });
  }

  initProductBundles() {

    if(document.querySelector(".product")) {

    document.querySelector(".product").delegateListener("change", `[name="bundles"]`, function (e) {

      publish("bundle_update", {
        data: {
          information: {
            default_price: JSON.parse(document.querySelector(`.element-price [data-info]`).dataset.info).price,
          },
        },
      });
    });
    }

    subscribe("bundle_update", ({ data }) => {
      let selectedBundle = document.querySelector(`[name="bundles"]:checked`);
      if (!selectedBundle) return;
      let discountValue = selectedBundle.dataset.discount;
      let discountType = selectedBundle.dataset.type;
      let currentDiscountAmount = selectedBundle.dataset.discountValue;
      let currentQuantityAmount = parseInt(selectedBundle.value);
      let price = data.information?.price || 0;
      let defaultPrice = data.information?.default_price || data.information?.price || 0;

      let badgeContainer = document.querySelector(`[data-variant-badge]`);

      badgeContainer.textContent = discountValue;
      badgeContainer.dataset.hide = discountValue === "";

      let variantMessageContainer = document.querySelector(`[data-variant-message]`);
      variantMessageContainer.textContent = discountValue !== "" ? window.variantStrings.variant_message_discount.replace("{{ discount }}", discountValue) : window.variantStrings.variant_message;

      if(discountValue == "") {
        variantMessageContainer.classList.remove("style--discount");
        if(document.querySelector(`[data-subscriptions]`)?.dataset?.subscriptions == "true") {
          document.querySelector(".sub_delivery_selection > span").classList.remove("hide");
          document.querySelector(".sub_delivery_selection > div").classList.add("hide");
        }
      } else { 
        
        if(document.querySelector(`[data-subscriptions]`)?.dataset?.subscriptions == "true") {
          document.querySelector(".sub_delivery_selection > span").classList.add("hide");
          document.querySelector(".sub_delivery_selection > div").classList.remove("hide");
        }
        variantMessageContainer.classList.add("style--discount");
      }

      let bundlesPriceContainers = document.querySelectorAll(`.element-bundles li`);
      if (price !== 0) {
        bundlesPriceContainers.forEach((el) => {
          let regularPriceContainer = el.querySelector(`.element-regular`);

          let salePriceContainer = el.querySelector(`.element-sale`);
          let elDiscountType = el.querySelector(`[name="bundles"]`).dataset.type;
          let singlePriceContainer = el.querySelector(`.element-qty span`);
          let discountAmount = salePriceContainer ? parseFloat(salePriceContainer.dataset.discount) : 1;
          let quantity = parseInt(el.querySelector(`[name="bundles"]`).value);

          // console.log(elDiscountType, discountAmount, salePriceContainer, parseFloat(salePriceContainer.dataset.discount));

          let regularPrice = this.formatMoney(price * quantity);
          let salePrice = this.formatMoney(price * discountAmount * quantity);
          if(discountType === "suma") {
            salePrice = this.formatMoney(price - discountAmount * 1);
          }

          regularPriceContainer.textContent = regularPrice;
          if (salePriceContainer) {
            salePriceContainer.textContent = salePrice;
          }

          document.querySelector(".product-form__quantity").classList.toggle("hide", elDiscountType === "kiekinis")
          
          if (singlePriceContainer) {
            if(discountType === "suma") {
              singlePriceContainer.textContent = this.formatMoney(price * discountAmount);
            } else {
              singlePriceContainer.textContent = this.formatMoney(price - discountAmount);
            }
          }
        });
      }

      console.log(discountType, defaultPrice, currentDiscountAmount);
      if(discountType === "suma") {
        this.updateProductPrice(this.formatMoney(defaultPrice - currentDiscountAmount * 1), this.formatMoney(defaultPrice * 1));
      } else {
        this.updateProductPrice(this.formatMoney(defaultPrice * currentDiscountAmount * currentQuantityAmount), this.formatMoney(defaultPrice * currentQuantityAmount));
      }
    });
  }

  updateProductPrice(price, comparePrice) {
    const priceContainer = document.querySelector(".price");

    if (!priceContainer) return;

    const regularPriceElements = priceContainer.querySelectorAll(".price-item--regular");
    const salePriceElement = priceContainer.querySelector(".price-item--sale");
    const priceSaleContainer = priceContainer.querySelector(".price__sale");
    const saleBadge = priceContainer.querySelector(".price__badge-sale");

    if (price === comparePrice) {
      if (regularPriceElements[0]) regularPriceElements[0].textContent = price;

      if (priceSaleContainer) priceSaleContainer.style.display = "none";
      if (saleBadge) saleBadge.style.display = "none";

      priceContainer.classList.remove("price--on-sale");
    } else {
      if (salePriceElement) salePriceElement.textContent = price;
      if (regularPriceElements[1]) regularPriceElements[1].textContent = comparePrice;

      if (priceSaleContainer) priceSaleContainer.style.display = "";
      if (saleBadge) saleBadge.style.display = "";

      priceContainer.classList.add("price--on-sale");
    }
  }

  initProductCardButtonHandler() {
    document.delegateListener("click", "button.element-button", async function () {
      const button = this;
      const variantId = button.dataset.id;

      if (!variantId) return;

      this.classList.add("style--buttonLoading");
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (!res.ok) throw new Error("Failed to add to cart");

        const addedItem = await res.json();

        // Fetch full cart and trigger update
        const cartRes = await fetch("/cart.js");
        const cartData = await cartRes.json();

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "custom-button",
          cartData: cartData,
          variantId: variantId,
        });
        this.classList.remove("style--buttonLoading");
      } catch (err) {
        console.error("Add to cart failed:", err);
        this.classList.remove("style--buttonLoading");
      }
    });
  }

  /*/__________________________________________________________________________________
  : Clicks the target element based on the attribute.
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initDataTriggerHandler() {
    document.body.addEventListener("click", (event) => {
      const button = event.target.closest("[data-trigger]");
      if (button) {
        const targetSelector = button.getAttribute("data-trigger");
        const targetElement = document.querySelector(targetSelector);
        if (targetElement) {
          targetElement.click();
        }
      }
    });
  }

  /*/__________________________________________________________________________________
  : Smooth scrolls to target elements with [data-scroll] 
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initSmoothScroll() {
    document.body.addEventListener("click", (event) => {
      const link = event.target.closest("[data-scroll]");
      if (link && link.getAttribute("href")) {
        event.preventDefault();
        const target = document.querySelector(link.getAttribute("href"));
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
  }

  /*/__________________________________________________________________________________
  : Initializes tooltips for elements with [data-snippet='tooltip']
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initTooltips() {
    document.body.addEventListener("mouseover", (event) => {
      const tooltip = event.target.closest("[data-snippet='tooltip']");
      if (tooltip) {
        tooltip.setAttribute("data-active", "true");
      }
    });

    // document.body.addEventListener("mouseout", (event) => {
    //   const tooltip = event.target.closest("[data-snippet='tooltip']");
    //   if (tooltip) {
    //     console.log("1", tooltip, event.target);
    //     tooltip.removeAttribute("data-active");
    //   }
    // });

    document.body.addEventListener("mouseout", (event) => {
      const tooltip = event.target.closest("[data-snippet='tooltip']");
      if (tooltip && !tooltip.contains(event.relatedTarget)) {
        console.log("1", tooltip, event.target);
        tooltip.removeAttribute("data-active");
      }
    });
  }

  /*/__________________________________________________________________________________
  : Format money
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  formatMoney(price) {
    const rate = Number(Shopify.currency.rate);
    let formatString = window.utils.moneyFormat.indexOf("{amount_with_comma_separator}}") > -1 ? "{amount_with_comma_separator}}" : "{amount}}";
    return window.utils.moneyFormat.replace(/\{.*\}/g, ((price * rate) / 100).toFixed(2));
  }

  /*/__________________________________________________________________________________
  : Manages height equalization for sections
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initHeightEqualizer() {
    this.applyHeightEqualization();
    setTimeout(() => {
      this.applyHeightEqualization();
    }, 1500);
    window.addEventListener("resize", () => this.applyHeightEqualization());
  }

  applyHeightEqualization() {
    document.querySelectorAll("section").forEach((section) => {
      if (section.querySelector(".slider--wrapper")) {
        section.querySelectorAll(".slider--wrapper").forEach((wrapper) => {
          this.equalizeHeight(wrapper);
          this.setHeightVariable(wrapper);
        });
      } else {
        this.equalizeHeight(section);
        this.setHeightVariable(section);
      }
    });
  }

  equalizeHeight(section) {
    const equalHeightElements = section.querySelectorAll('[data-height="equal"]');
    if (equalHeightElements.length > 0) {
      let maxHeight = 0;
      equalHeightElements.forEach((element) => {
        element.style.height = "auto";
        maxHeight = Math.max(maxHeight, element.offsetHeight);
      });

      if (maxHeight > 20) {
        section.style.setProperty("--element-heights", `${maxHeight}px`);
      }
    }
  }

  setHeightVariable(section) {
    const setHeightElement = section.querySelector('[data-height="set"]');
    if (setHeightElement) {
      const height = setHeightElement.offsetHeight;
      // console.log(setHeightElement, height);
      if (height > 20) {
        section.style.setProperty("--element-height", `${height}px`);
      }
    }
  }

  /*/__________________________________________________________________________________
  : Custom event delegation
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  extendEventTargetPrototype() {
    if (!EventTarget.prototype.delegateListener) {
      EventTarget.prototype.delegateListener = function (eventType, selector, callback) {
        let handler = (event) => {
          let matched;
          [].slice
            .call(this.querySelectorAll(selector))
            .reverse()
            .filter((el) => el.contains(event.target))
            .forEach((el) => {
              if (matched === undefined || matched !== false) {
                matched = callback.call(el, event);
              }
            });
        };
        this.addEventListener(eventType, handler);
        return handler;
      };
    }
  }

  /*/__________________________________________________________________________________
  : Sticky Button Click Handler - Scrolls to submit button 
  ‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾‾/*/
  initStickyButtonHandler() {
    const stickyButton = document.querySelector(".sticky--button .button--primary");
    if (stickyButton) {
      stickyButton.addEventListener("click", () => {
        const targetElement = document.querySelector('[type="submit"].product-form__submit');
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      });
    }
  }
}

new Utils();

class DropdownElement extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    Element.prototype.on = function (event, callback, options = false) {
      if (!this._eventNamespaces) {
        this._eventNamespaces = {};
      }
      this._eventNamespaces[event] = callback;
      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    };

    Element.prototype.off = function (event) {
      if (!this._eventNamespaces) return;
      const callback = this._eventNamespaces[event];
      if (callback) {
        this.removeEventListener(event.split(".")[0], callback);
        delete this._eventNamespaces[event];
      }
      return this;
    };

    this.cleanupText();
    
    const type = this.dataset.type || "dropdown";

    if (type === "more/less") {
      this.initializeReadMore();
    } else {
      this.initializeDropdown();
    }
  }

  cleanupText() {
    const paragraphs = this.querySelectorAll(".dropdown--inner p");
    paragraphs.forEach((paragraph) => {
      paragraph.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          child.textContent = child.textContent.trim().replace(/\s+/g, " ");
        }
      });
    });

    if (this.querySelector(".dropdown--inner").textContent.trim() === "") {
      this.classList.add("hide");
    }
  }

initializeReadMore() {
  const column = this.closest('.grid--inner');
  const trigger = this.querySelector('[data-dropwdown="trigger"]');
  const body = this.querySelector('[data-dropwdown="body"]');
  const inner = this.querySelector(".dropdown--inner");
  if (!inner || !body) return;

  trigger.style.display = "none";

  // Ensure body is visible for measurement
  body.style.height = "auto";
  body.style.overflow = "visible";

  const target = this.closest(".grid--wrapper")?.querySelector("[data-target]");
  let fullHeight = inner.scrollHeight;
  let collapsedHeight;

  const calculateHeights = () => {
    fullHeight = inner.scrollHeight;
    const baseCollapsed = target
      ? Math.min(fullHeight, target.offsetHeight)
      : Math.floor(fullHeight / 2);

    const heading = column.querySelector("h2");
    let headingHeight = 0;
    if(heading) {
      headingHeight = heading ? heading.clientHeight + parseFloat(window.getComputedStyle(heading).marginBottom) : 0;
    }
    
    const buttonHeight = toggleBtn.clientHeight;

    collapsedHeight = baseCollapsed - buttonHeight - headingHeight - 48;

    if (!expanded) {
      inner.style.height = `${collapsedHeight}px`;
    }
  };

  let expanded = false;

  let toggleBtn = this.querySelector(".dropdown-toggle-btn");
  if (!toggleBtn) {
    toggleBtn = document.createElement("button");
    toggleBtn.className = "dropdown-toggle-btn";
    this.appendChild(toggleBtn);
  }
  toggleBtn.textContent = "Daugiau";

  calculateHeights();

  inner.style.overflow = "hidden";
  inner.style.transition = "height 0.3s ease";

  toggleBtn.on("click.moreless", () => {
    if (expanded) {
      inner.style.height = `${collapsedHeight}px`;
      toggleBtn.textContent = "Daugiau";
    } else {
      fullHeight = inner.scrollHeight;
      inner.style.height = `${fullHeight}px`;
      toggleBtn.textContent = "Mažiau";
    }
    expanded = !expanded;
  });

  // Recalculate on window resize
  window.addEventListener("resize", calculateHeights);

    setTimeout(calculateHeights, 900);

  window.addEventListener("load", () => {
    setTimeout(calculateHeights, 50);
    setTimeout(calculateHeights, 500);
  });
}


  initializeDropdown() {
    const selectors = {
      trigger: '[data-dropwdown="trigger"]',
      body: '[data-dropwdown="body"]',
      inner: ".dropdown--inner",
    };

    const classes = {
      open: "is-open",
      transitioning: "is-transitioning",
    };

    let isTransitioning = false;

    const triggers = this.querySelectorAll(selectors.trigger);
    triggers.forEach((trigger) => {
      const state = trigger.classList.contains(classes.open);
      trigger.setAttribute("aria-expanded", state);

      trigger.off("click.dropdown");
      trigger.on("click.dropdown", (evt) => this.toggleDropdown(evt, selectors, classes, isTransitioning));
    });
  }

  closeOtherDropdownsWithSameName(currentTrigger, selectors, classes) {
    const dataName = currentTrigger.getAttribute("data-name");
    if (!dataName) return;

    const otherTriggers = document.querySelectorAll(
      `[data-dropwdown="trigger"][data-name="${dataName}"].${classes.open}`
    );

    console.log(otherTriggers, dataName);

    otherTriggers.forEach((otherTrigger) => {
      if (otherTrigger !== currentTrigger) {
        const otherBodyId = otherTrigger.getAttribute("aria-controls");
        const otherBody = otherTrigger.closest("dropdown-element").querySelector(`#${otherBodyId}`);
        
          console.log(otherTrigger, otherBodyId, this);

        if (otherBody) {
          const contentHeight = otherBody.querySelector(selectors.inner).offsetHeight;
          otherBody.style.height = `${contentHeight}px`;


          requestAnimationFrame(() => {
            otherBody.style.height = "0";
          });

          otherBody.addEventListener(
            "transitionend",
            () => {
              otherBody.style.height = "0";
              otherBody.classList.remove(classes.open);
              otherTrigger.setAttribute("aria-expanded", false);
              otherTrigger.classList.remove(classes.open);
            },
            { once: true }
          );
        }
      }
    });
  }

  toggleDropdown(evt, selectors, classes, isTransitioning) {
    if (isTransitioning) return;

    isTransitioning = true;

    const trigger = evt.currentTarget;
    const isOpen = trigger.classList.contains(classes.open);
    const bodyId = trigger.getAttribute("aria-controls");
    const body = this.querySelector(`#${bodyId}`);

    if (!body) {
      isTransitioning = false;
      return;
    }

    
    // Close other dropdowns with the same data-name
    this.closeOtherDropdownsWithSameName(trigger, selectors, classes);
    
    const contentHeight = body.querySelector(selectors.inner).offsetHeight;

    if (isOpen) {
      body.style.height = `${contentHeight}px`;
      requestAnimationFrame(() => {
        body.style.height = "0";
      });
    } else {
      body.style.height = "0";
      requestAnimationFrame(() => {
        body.style.height = `${contentHeight}px`;
      });
    }

    body.addEventListener(
      "transitionend",
      () => {
        body.style.height = isOpen ? "0" : "auto";
        body.classList.toggle(classes.open, !isOpen);
        isTransitioning = false;
      },
      { once: true }
    );

    trigger.setAttribute("aria-expanded", !isOpen);
    trigger.classList.toggle(classes.open, !isOpen);
  }
}

customElements.define("dropdown-element", DropdownElement);

class SliderElement extends HTMLElement {
  async connectedCallback() {
    const settings = this.getAttribute("data-settings");
    const parsedSettings = settings ? JSON.parse(settings) : {};
    const arrowNextButtons = [];
    const arrowPrevButtons = [];

    let swiperContainer = this.querySelector(".swiper");

    const parentSection = this.closest(".slider--wrapper") || this.closest("section");
    const paginationElement = parentSection ? parentSection.querySelector(".swiper-pagination") : null;
    const progressElement = parentSection ? parentSection.querySelector(".swiper-pagination.style--progressbar") : null;
    const scrollbarElement = parentSection ? parentSection.querySelector(".swiper-scrollbar") : null;

    const nextButton = parentSection?.querySelector(".swiper-button-next:not(.style--secondary)");
    const prevButton = parentSection?.querySelector(".swiper-button-prev:not(.style--secondary)");
    const nextButtonSecondary = parentSection?.querySelector(".swiper-button-next.style--secondary");
    const prevButtonSecondary = parentSection?.querySelector(".swiper-button-prev.style--secondary");

    if (nextButton && prevButton) {
      arrowNextButtons.push(nextButton);
      arrowPrevButtons.push(prevButton);
    }

    if (nextButtonSecondary && prevButtonSecondary) {
      arrowNextButtons.push(nextButtonSecondary);
      arrowPrevButtons.push(prevButtonSecondary);
    }

    const defaultSettings = {
      loop: true,
      spaceBetween: 10,
      autoplay: {
        delay: 8000,
      },
      navigation: {
        nextEl: arrowNextButtons,
        prevEl: arrowPrevButtons,
      },
    };

    if (progressElement) {
      defaultSettings.pagination = {
        el: progressElement,
        type: "progressbar",
      };
    } else if(paginationElement) {

      defaultSettings.pagination = {
        el: paginationElement,
        clickable: true,
      };
    }

    const updateCounter = (swiperInstance) => {
      const counterElement = parentSection?.querySelector(".swiper-counter");
      if (!counterElement) return;
      const total = swiperInstance.slides.length;
      const current = swiperInstance.realIndex + 1;
      
      counterElement.innerHTML = `${current.toString().padStart(2, "0")} / <span>${total.toString().padStart(2, "0")}</span>`; 
    };

    if(parentSection?.querySelector(".swiper-counter")) {
      defaultSettings.on = {
        slideChangeTransitionEnd(swiper) {
          updateCounter(swiper);
        },
      };
    }

    if (parsedSettings.thumbs) {
      parsedSettings.thumbs.swiper = parentSection.querySelector(".slider-thumbs .swiper");
      defaultSettings.pagination = {};
    }

    if (scrollbarElement) {
      defaultSettings.scrollbar = {
        el: scrollbarElement,
      };
    }
    
    if(this.classList.contains(".main-gallery")) {
      console.log(this);
    }

    const swiperSettings = {
      ...defaultSettings,
      ...parsedSettings
    };

    // console.log(swiperSettings);

    const dataContent = this.getAttribute("data-content");
    if(dataContent === "") {
      this.closest("section").classList.add("hide");
      return;
    }

    if (dataContent) {
      this.querySelector(".swiper-wrapper").classList.add("style--sectionLoading");


      const query = dataContent
        .split(",")
        .map((item) => `"${item}"`)
        .join("+OR+");
      const fetchUrl = `/search?q=${query}&view=slider`;

      try {
        const response = await fetch(fetchUrl);
        if (response.ok) {
          const html = await response.text();
          swiperContainer.querySelector(".swiper-wrapper").innerHTML = html;
          swiperContainer = this.querySelector(".swiper");

          // console.log(html);

          if (swiperContainer) {
            new Swiper(swiperContainer, swiperSettings);
          } else {
            console.error("Swiper container not found after content update.");
          }
        } else {
          console.error("Failed to fetch slider content:", response.status);
        }
      } catch (error) {
        console.error("Error fetching slider content:", error);
      }
    } else {
      if (swiperContainer) {
        new Swiper(swiperContainer, swiperSettings);
      }
    }

    this.removeAttribute("data-settings");
    this.querySelector(".swiper-wrapper").classList.remove("style--sectionLoading");
  }
}

customElements.define("slider-element", SliderElement);

class UpsellElement extends HTMLElement {
  constructor() {
    super();
    this.upsellProductId = null;
    this.upsellProductIds = [];
  }

  connectedCallback() {
    this.updateSelectedUpsell();
    this.addEventListeners();
    this.checkAndFixCart();
  }

  addEventListeners() {
    this.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.addEventListener("change", () => this.handleSelectionChange());
    });

    document.addEventListener("upsell:update", (event) => {
      this.checkAndFixCart(event.detail);
    });
  }

  updateSelectedUpsell() {
    let checkedRadio = this.querySelector("input[type='radio']:checked");
    this.upsellProductId = checkedRadio ? checkedRadio.value : null;
    this.upsellProductIds = Array.from(this.querySelectorAll("input[type='radio']")).map((input) => input.value);
  }

  async fetchCart() {
    try {
      let response = await fetch("/cart.js");
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error("UpsellElement: Error fetching cart:", error);
      return null;
    }
  }

  async checkAndFixCart(cart = null) {
    let cartData = cart || (await this.fetchCart());
    if (!cartData) return;

    let upsellsInCart = cartData.items.filter((item) => this.upsellProductIds.includes(String(item.id))).map((item) => String(item.id));

    let hasProducts = cartData.items.some((item) => !this.upsellProductIds.includes(String(item.id))); // Check for non-upsell items
    let updates = {};

    if (upsellsInCart.length > 1) {
      upsellsInCart.forEach((id) => {
        if (id !== this.upsellProductId) updates[id] = 0;
      });
    }

    if (hasProducts && !upsellsInCart.includes(this.upsellProductId) && this.upsellProductId) {
      updates[this.upsellProductId] = 1;
    }

    if (!hasProducts && upsellsInCart.length > 0) {
      upsellsInCart.forEach((id) => (updates[id] = 0));
    }

    if (Object.keys(updates).length > 0) {
      this.modifyCart({ updates, sections: this.getSectionSelectors() });
    }
  }

  handleSelectionChange() {
    let previouslyChecked = this.upsellProductId;
    this.updateSelectedUpsell();

    let updates = {};

    if (previouslyChecked && previouslyChecked !== this.upsellProductId) {
      updates[previouslyChecked] = 0;
    }

    if (this.upsellProductId) {
      updates[this.upsellProductId] = 1;
    }

    if (Object.keys(updates).length > 0) {
      this.modifyCart({ updates, sections: this.getSectionSelectors() });
    }
  }

  modifyCart(updates) {
    document.querySelector(".cart-main")?.classList.add("style--sectionLoading");

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updates),
    })
      .then((response) => response.json())
      .then((cart) => {
        publish("cartPage-update", {
          source: "cart-items",
          cartData: cart,
          variantId: this.upsellProductId,
        });
      })
      .catch((error) => console.error("UpsellElement: Error updating cart:", error));
  }

  getSectionSelectors() {
    return [document.getElementById("main-cart-footer")?.dataset.id, "cart-icon-bubble", "cart-live-region-text", document.getElementById("main-cart-items")?.dataset.id].filter(Boolean);
  }
}

customElements.define("upsell-element", UpsellElement);

class DynamicProducts extends HTMLElement {
  constructor() {
    super();
    this.debounceTimer = null;
    this.cache = new Map();
    this.type = "sku";
    this.debouncedLoadContent = debounce(this.loadContent.bind(this), 200);
  }

  connectedCallback() {
    this.ids = this.getAttribute("data-content");
    this.container = this.querySelector(".container");
    this.loadContent();
  }

  async loadContent() {
    if (!this.container || !this.ids) {
      console.error("Missing Data");
      return;
    }

    if (this.cache.has(this.ids)) {
      this.container.innerHTML = this.cache.get(this.ids);
      return;
    }

    const query = this.ids
      .split(",")
      .map((item) => encodeURIComponent(`"${item.trim()}"`))
      .join("+OR+");
    const fetchUrl = `/search?q=${query}&view=dynamic`;

    try {
      const response = await fetch(fetchUrl);
      if (response.ok) {
        const html = await response.text();
        this.cache.set(this.ids, html);
        this.container.innerHTML = html;
      } else {
        console.error("Failed to fetch slider content:", response.status);
      }
    } catch (error) {
      console.error("Error fetching slider content:", error);
    }
  }

  static get observedAttributes() {
    return ["data-content"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-content" && oldValue !== newValue) {
      this.ids = newValue;
      this.debouncedLoadContent();
    }
  }

  refresh() {
    this.debouncedLoadContent();
  }

  disconnectedCallback() {
    clearTimeout(this.debounceTimer);
  }
}

customElements.define("dynamic-products", DynamicProducts);

class MapElement {
  constructor(mapElementId) {
    this.markers = [];
    this.markersIds = [];
    this.map = null;
    this.infowindow = new google.maps.InfoWindow();
    this.tileListener = null;
    this.mapElementId = mapElementId;
  }

  async initMap() {
    this.map = new google.maps.Map(document.getElementById(this.mapElementId), {
      zoom: 1,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    console.log(this.map);

    await this.setMarkers();
    this.tileListener = google.maps.event.addListener(this.map, "tilesloaded", () => this.showLocation());
    this.attachShowInMapHandlers();
  }

  async setMarkers() {
    try {
      const response = await fetch("/blogs/locations?view=locations_json");
      const data = await response.text();

      const icon = {
        url: "https://cdn.shopify.com/s/files/1/0695/3002/6153/files/maps_marker.png?v=1746005605",
        size: new google.maps.Size(27, 38),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(-2, 38),
      };

      const bounds = new google.maps.LatLngBounds();
      const locations = JSON.parse(data) || [];

      locations.forEach((shop) => {
        const { lat, lng, name, handle } = shop;
        if (!lat || !lng) return;

        const myLatLng = new google.maps.LatLng(lat, lng);
        const marker = new google.maps.Marker({
          position: myLatLng,
          map: this.map,
          icon,
          title: name,
          zIndex: 1,
        });

        marker.addListener("click", () => {
          fetch(`/blogs/${handle}?view=location_json`)
            .then((response) => response.text())
            .then((res) => {
              this.infowindow.setContent(res);
              this.infowindow.open(this.map, marker);
            });
        });

        this.markers.push(marker);
        this.markersIds.push({ marker, id: shop.id });
        bounds.extend(myLatLng);
      });

      this.map.fitBounds(bounds);
      this.setupClosestButton();
      this.setupMarkerCluster();
      this.adjustSingleZoom(locations.length);
    } catch (err) {
      console.error("Error loading markers:", err);
    }
  }

  setupClosestButton() {
    const button = document.querySelector(".show-closest");
    if (!navigator.geolocation || !button) return;

    button.style.display = "block";
    button.addEventListener("click", () => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.findClosestMarker(pos);
        },
        () => this.handleLocationError(true)
      );
    });
  }

  findClosestMarker(pos) {
    const R = 6371;
    const distances = [];
    const closestMarkers = [];
    let closest = -1;

    console.log(pos);

    this.markers.forEach((marker, i) => {
      const mlat = marker.getPosition().lat();
      const mlng = marker.getPosition().lng();
      const dLat = ((mlat - pos.lat) * Math.PI) / 180;
      const dLng = ((mlng - pos.lng) * Math.PI) / 180;

      const a = Math.sin(dLat / 2) ** 2 + Math.cos((pos.lat * Math.PI) / 180) * Math.cos((mlat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c;

      distances[i] = d;
      closestMarkers.push({ index: i, distance: d });

      if (closest === -1 || d < distances[closest]) {
        closest = i;
      }
    });

    closestMarkers.sort((a, b) => a.distance - b.distance);
    const bounds = new google.maps.LatLngBounds();
    closestMarkers.slice(0, 3).forEach(({ index }) => {
      bounds.extend(this.markers[index].getPosition());
    });

    console.log(closestMarkers);
    console.log(bounds);

    this.map.fitBounds(bounds);
  }

  attachShowInMapHandlers() {
    this.markersIds.forEach(({ marker, id }) => {
      const button = document.querySelector(`[data-id="${id}"]`);
      if (!button) return;

      button.addEventListener("click", (e) => {
        e.preventDefault();
        google.maps.event.trigger(marker, "click");
        this.map.setCenter(marker.getPosition());
        this.smoothZoom(16);
      });
    });
  }

  setupMarkerCluster() {
    const clusterImagePath = "https://cdn.shopify.com/s/files/1/0695/3002/6153/files/maps_cluster.png?v=1746006536";
    const mcOptions = {
      styles: [
        {
          url: clusterImagePath,
          width: 38,
          height: 53,
          anchorIcon: [53, 19],
          anchorText: [-7, 0],
          textSize: 14,
          textColor: "#595959",
        },
      ],
    };

    new MarkerClusterer(this.map, this.markers, mcOptions);
  }

  adjustSingleZoom(count) {
    if (count === 1) {
      const listener = google.maps.event.addListener(this.map, "idle", () => {
        if (this.map.getZoom() > 16) this.map.setZoom(16);
        google.maps.event.removeListener(listener);
      });
    }
  }

  showLocation(variable = true) {
    if (variable) this.showLocation(false);
    google.maps.event.removeListener(this.tileListener);
  }

  smoothZoom(targetZoom, currentZoom = this.map.getZoom()) {
    if (currentZoom >= targetZoom) return;

    const zoomChangeListener = google.maps.event.addListener(this.map, "zoom_changed", () => {
      google.maps.event.removeListener(zoomChangeListener);
      this.smoothZoom(targetZoom, currentZoom + 1);
    });

    setTimeout(() => {
      this.map.setZoom(currentZoom);
    }, 80);
  }
}

function initMap() {
  const mapElement = new MapElement("map");
  mapElement.initMap();
}

class PopupElement extends HTMLElement {
  constructor() {
    super();
    this.togglePopup = this.togglePopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('button[type="button"]');
    this.popup = this.querySelector('.popup');
    this.inner = this.querySelector('.popup--inner');
    this.closeBtn = this.querySelector('[data-controls="close"]');

    if (this.button && this.popup) {
      this.button.addEventListener('click', this.togglePopup);
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.closePopup);
    }

    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  togglePopup() {
    const isVisible = this.popup.classList.contains('visible');
    if (isVisible) {
      this.closePopup();
    } else {
      this.popup.classList.add('visible');
      this.popup.setAttribute('aria-hidden', 'false');
      this.inner.focus();
    }
  }

  closePopup() {
    this.popup.classList.remove('visible');
    this.popup.setAttribute('aria-hidden', 'true');
    this.button.focus();
  }

  handleOutsideClick(e) {
    // console.log(e, e.target, this, !this.contains(e.target));
        
    if (e.target.classList.contains("popup")) {
      this.closePopup();
    }
    // if (!this.contains(e.target)) {
    //   this.closePopup();
    // }
  }

  handleKeydown(e) {
    if (!this.popup.classList.contains('visible')) return;

    if (e.key === 'Escape') {
      this.closePopup();
    }

    if (e.key === 'Tab') {
      const focusable = this.popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }
}

customElements.define('popup-element', PopupElement);


class QuizElement extends HTMLElement {
  constructor() {
    super();
    this.resultsPageHandle = "quiz-results";
    this.sections = this.querySelectorAll(".element-section");
    this.currentIndex = 0;
    this.totalSteps = this.sections.length - 1;
    this.quizIndex = this.dataset.quiz;
    this.header = this.querySelector(".element-header");
    this.progressBar = this.querySelector(".element-headerProgress div");
    this.loadingOverlay = this.querySelector(".element-loading");
    this.backButton = this.querySelector(".element-headerButton button");
    this.cartButton = this.querySelector(".element-cart");
    this.stepsWrapper = this.querySelector(".element-headerSteps > span");
    this.currentStepSpan = this.querySelector("[data-current]");
    this.category = localStorage.getItem("selectedQuizId") || "";
    this.responses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    this.responsesFull = JSON.parse(localStorage.getItem("quizResponsesFull")) || {};
    this.emailSectionIndex = parseInt(document.querySelector(".section-email").dataset.index);
    this.cache = {};
  }

  connectedCallback() {
    this.initializeQuiz();
    this.savedQuiz("load");
    this.klaviyoForm();
    
    window.addEventListener("hashchange", () => this.loadFromHash());
    this.delegateListener("change", `#checkobx-subs`, (e) => {
      let checked = e.target.checked;

      document.querySelectorAll(`[data-section="quiz_products"] .grid-item`).forEach((el) => {
        let discountPrice = el.querySelector(".discounted");
        let defaultPrice = el.querySelector(".default");
        let badgeElement = el.querySelector(".element-badge");

        discountPrice.classList.toggle("hide");
        defaultPrice.classList.toggle("hide");
        badgeElement.classList.toggle("hide");
      });

      document.querySelectorAll(".sub-element").forEach((el) => {
        el.classList.toggle("hide");
      });
    });


    this.delegateListener("click", `.section-results [data-id]`, (e) => this.productCartButton(e));

    this.delegateListener("click", `.variant-option`, async (e) => {
      const button = e.target.closest('.variant-option');
      const card = button.closest('.grid-item');
      const cartButton = button.closest('.grid-item').querySelector("[data-id]");
      if (!button) return;

      const ul = button.closest('ul');
      const optionIndex = [...ul.parentElement.querySelectorAll('ul')].indexOf(ul);
      const container = button.closest('.element-variants');
      const variants = JSON.parse(container.querySelector("[data-json]").textContent);

      // 1. Update button UI (toggle style--selected)
      ul.querySelectorAll('.variant-option').forEach(btn => btn.classList.remove('style--selected'));
      button.classList.add('style--selected');

      // 2. Get all selected values
      const selectedOptions = [...container.querySelectorAll('ul')].map(group => {
        const selected = group.querySelector('.style--selected');
        return selected ? selected.dataset.value : null;
      });

      // 3. Match variant
      const matchingVariant = variants.find(v =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (matchingVariant) {
        cartButton.dataset.id = matchingVariant.id;
      } else {
        cartButton.dataset.id = "";
      }

      const url = `/products/${ button.dataset.handle }?variant=${ matchingVariant.id }&view=quiz_card`;
      const contentWrapper = card.querySelector(".element-group");

      if (this.cache[url]) {
        contentWrapper.innerHTML = this.cache[url];
        return;
      }
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Network response was not ok");

        const html = await res.text();
        this.cache[url] = html;
        contentWrapper.innerHTML = html;
      } catch (err) {
        console.error("Variant fetch failed:", err);
      }
    });
  }

  initializeQuiz(index = 0) {
    const setGroupState = (groups, hidden, disableInputs) => {
      groups.forEach((group) => {
        group.dataset.hide = hidden ? "true" : "false";
        group.querySelectorAll("input, select").forEach((input) => {
          input.disabled = disableInputs;
          // if(disableInputs && input.type == "") {
          //   input.checked = false;
          // }
        });
      });
    };

    const toggleOptions = (value) => {
      const optionsPrimary = this.querySelectorAll(".options-primary");
      const optionsSecondary = this.querySelectorAll(".options-secondary");

      const isPrimaryVisible = value == 2;
      setGroupState(optionsPrimary, !isPrimaryVisible, !isPrimaryVisible);
      setGroupState(optionsSecondary, isPrimaryVisible, isPrimaryVisible);
    };

    toggleOptions(this.responses["option_3"]);

    this.delegateListener("change", `[name="option_3"]`, (e) => {
      toggleOptions(e.target.value);
    });

    this.loadFromHash(index, true);
    this.populateInputs();
    this.updateProgress();
    this.addNavigation();
    this.weightInputSetup();
  }

  loadFromHash(ind, event = false) {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let urlParams = match ? match[1] : "";
    let index = parseInt(window.location.hash.replace("#step-", ""), 10) || ind;
    
    console.log(window.location.pathname, match, urlParams);

    if (urlParams && !urlParams.includes('=')) {
      index = this.totalSteps;
    }

    if (urlParams) {
      index = this.totalSteps;
    }
    
    if (isNaN(index) || index < 0 || index > this.totalSteps) {
      index = 0;
    }

    this.toggleSection(this.currentIndex, index);
    this.currentIndex = index;
    this.updateProgress();

    if((this.emailSectionIndex - 1) === this.currentIndex) {
      this.populateFormInputs(document.querySelector(".section-email"));
    }
    
    if (this.currentIndex === this.totalSteps) {
      if (!event) {
        return;
      }
      this.fetchResultsPage();
    }
  }

  collectResponses(index) {
    const section = this.sections[index];
    const inputs = section.querySelectorAll("[name]:not([disabled])");
    const checkboxGroupsFull = {};

    inputs.forEach((input) => {
      
      const rawName = input.name;
      const headingEl = input.closest(".element-section")?.querySelector("h2.heading");

      const fullName = headingEl?.dataset.name?.trim() || headingEl?.textContent.trim();
      let labelText = input.nextElementSibling?.textContent?.trim() || input.value;

      // Skip emails from full response
      const skipFull = input.closest(".section-email");
      
      if(input.nextElementSibling?.querySelector(".element-value")) {
        labelText = input.nextElementSibling?.querySelector(".element-value")?.textContent?.trim();
      }

      // RAW RESPONSES (by input name)
      if (input.type === "checkbox") {
        if (!this.responses[rawName] || !Array.isArray(this.responses[rawName])) {
          this.responses[rawName] = [];
        }

        if (input.checked) {
          if (!this.responses[rawName].includes(input.value)) {
            this.responses[rawName].push(input.value);
          }
        } else {
          this.responses[rawName] = this.responses[rawName].filter(val => val !== input.value);
        }

        if (this.responses[rawName].length === 0) {
          delete this.responses[rawName];
        }
      } else if (input.type === "text") {
        this.responses[rawName] = input.value;
        if (this.responses[rawName].length === 0) {
          delete this.responses[rawName];
        }
      } else if (input.type === "number") {
        this.responses[rawName] = input.value;
        if (this.responses[rawName].length === 0) {
          delete this.responses[rawName];
        }
      } else if (input.type === "radio" && input.checked) {
        this.responses[rawName] = input.value;
      } else if (input.type === "select-one") {
        this.responses[rawName] = input.value;
      } else if (input.type === "hidden") {
        this.responses[rawName] = input.value.replace(".", "_");
      }

      // FULL RESPONSES (by heading text)
      if (!fullName || skipFull) return;

      if (input.type === "checkbox") {
        if (!checkboxGroupsFull[fullName]) checkboxGroupsFull[fullName] = [];
        if (input.checked) {
          checkboxGroupsFull[fullName].push(labelText.replaceAll(".", ""));
        }
      } else if (input.type === "radio" && input.checked) {
        this.responsesFull[fullName] = labelText.replaceAll(".", "");
      } else if (input.type === "text") {
        this.responsesFull[fullName] = input.value.replaceAll(".", "");
        
      } else if (input.type === "number") {
        this.responsesFull[fullName] = input.value.replaceAll(".", "") + input.getAttribute("placeholder");
         
      } else if (input.type === "select-one") {
        this.responsesFull[fullName] = input.value.replaceAll(".", "");
      } else if (input.type === "hidden") {
        this.responsesFull[rawName] = input.value.replace(".", "_");
      }
    });

    // Finalize grouped checkboxes for full responses
    Object.entries(checkboxGroupsFull).forEach(([name, values]) => {
      if (values.length > 0) {
        this.responsesFull[name] = values.join("; ").replaceAll(".", "");
      } else {
        delete this.responsesFull[name];
      }
    });

    localStorage.setItem("quizResponses", JSON.stringify(this.responses));
    localStorage.setItem("quizResponsesFull", JSON.stringify(this.responsesFull));
  }

  populateInputs() {
    
          // input.value = values[index].replace("_", ".") || "";
    Object.keys(this.responses).forEach((name) => {
      let inputs = this.querySelectorAll(`[name='${name}']:not([disabled])`);
      inputs.forEach((input, index) => {
        if (input.type === "radio") {
          input.checked = this.responses[name] === input.value;
        } else if (input.type === "checkbox") {
          let values = this.responses[name] || [];
          input.checked = values.includes(input.value);
        } else if (input.type === "select-one") {
          console.log(input, `option[value='${this.responses[name]}']`);
          if(input.querySelector(`option[value='${this.responses[name]}']`)) {
            input.querySelector(`option[value='${this.responses[name]}']`).selected = true;
          } else {
            delete this.responses[name];
          }
          
        } else if (input.type === "text" ) {
          input.value = this.responses[name];
        }
      });
    });
  }

  getParamsFromUrl() {
    let match = window.location.pathname.match(/^\/pages\/[^/]+\/([^#/]+)/);
    let paramsString = match ? match[1] : "";
    let params = new URLSearchParams(paramsString);
    let urlResponses = {};

    for (let [key, value] of params.entries()) {
      if (value.includes("+")) {
        urlResponses[key] = value.split("+");
      } else {
        urlResponses[key] = value;
      }
    }

    return urlResponses;
  }

  toggleSection(fromIndex, toIndex) {
    console.log(this.sections[toIndex].classList);
    if(this.sections[toIndex].classList.contains("section-email") || this.sections[toIndex].classList.contains("section-results")) {
      let userQuizData = this.responsesFull
      let queryParams = new URLSearchParams();
      Object.keys(this.responses).forEach((key) => {
        let value = this.responses[key];
        queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
      });

      queryParams = queryParams.toString();

      this.setFormInputValues();

      // klaviyo.identify({
      //    'Quiz URL' : "https://" + queryParams,
      //     ...userQuizData
      // });
      
      if(this.sections[toIndex].innerText.includes("Thanks for subscribing!")) {
        location.reload();
      }
    }

    if (this.sections[fromIndex]) this.sections[fromIndex].dataset.active = "false";
    if (this.sections[toIndex]) this.sections[toIndex].dataset.active = "true";
  }

  updateProgress() {
    let progress = ((this.currentIndex + 1 - 1) / (this.totalSteps + 1 - 1)) * 100;
    this.progressBar.style.width = `${progress}%`;
    this.currentStepSpan.innerHTML = `${(this.currentIndex + 1)}/${this.totalSteps}`;
    this.currentStepSpan.classList.remove("hide");
    this.backButton.classList.remove("hide");
    this.backButton.nextElementSibling.classList.add("hide");
    this.cartButton.classList.add("hide");
    this.header.classList.remove("style--results");
    
    if (this.currentIndex === this.totalSteps) {
      this.backButton.classList.add("hide");
      this.cartButton.classList.remove("hide");
      this.backButton.nextElementSibling.classList.remove("hide");
      this.header.classList.add("style--results");
      this.currentStepSpan.innerHTML = `<button id="product-section" type="button" class="button--primary">Produktai</button>`;
    }

    if (this.currentIndex == 0) {
      this.backButton.classList.add("hide");
      this.currentStepSpan.classList.add("hide");
    }

    this.updateName();
  }

  addNavigation() {
    const backButton = this.querySelector("[data-button='back']");
    if (backButton) {
      backButton.addEventListener("click", () => this.prevSection());
    }
        
    this.sections.forEach((section, index) => {
      if (section.classList.contains("section-results") || section.classList.contains("section-dashboards")) return;

      if (section.querySelector(`[data-type="Single Option"]`)) {
        section.querySelectorAll(`[data-type="Single Option"] input`).forEach((el) => {
          el.addEventListener("click", (e) => {
            this.nextSection(index);
          });
        });
        return;
      }

      let nextButton = section.querySelector(".next-button");
      if (!nextButton) {
        nextButton = document.createElement("button");
        nextButton.classList.add("next-button", "button--primary");
        nextButton.textContent = "Toliau";
        nextButton.addEventListener("click", () => this.nextSection(index));
        section.querySelector(".section--inner .element-button").appendChild(nextButton);
      } else {
        nextButton.addEventListener("click", () => this.nextSection(index));
      }
    });

    this.delegateListener("click", `[data-section="quiz_hero"] button`, () => {
      this.querySelector(`[data-section="quiz_blocks"]`).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
    
    this.delegateListener("click", `#product-section`, () => {
      const quizSection = this.querySelector(`[data-section="quiz_info2"]`);
      const header = this.querySelector(`[data-section="quiz-element"] > header`);
    
      const headerHeight = header ? header.offsetHeight : 0;
      const sectionTop = quizSection.getBoundingClientRect().top + window.scrollY;
      
      window.scrollTo({
        top: sectionTop - headerHeight,
        behavior: "smooth",
      });
    });
    
    this.delegateListener("click", `.element-cart`, () => {
      document.querySelector("#cart-icon-bubble").click()
    });
  }

  populateFormInputs(section) {
    const quizResponses = JSON.parse(localStorage.getItem("quizResponses")) || {};
    const inputs = section.querySelectorAll("input[type='email']");
    
    console.log(quizResponses);

    inputs.forEach((input) => {
      const name = input.placeholder.replaceAll(" ", "_").toLowerCase();
      if (quizResponses[name]) {
        input.value = quizResponses[name];
        const event = new Event("input", { bubbles: true });
        input.dispatchEvent(event);
      }
    });
  }
  
  updateName(oldName) {
    // Replace {vardas} name
    if (this.responses["option_2"]) {
      this.querySelectorAll('p, .heading, .element-value').forEach(el => {
        if (el.childNodes.length === 1 && el.childNodes[0].nodeType === Node.TEXT_NODE) {
          el.textContent = el.textContent.replace(/{\w+}/g, this.responses["option_2"]);
          if(oldName) {
            el.textContent = el.textContent.replace(oldName, this.responses["option_2"]);
          }
        }
      });
    }
  }

  nextSection(index) {
    let oldName = this.responses["option_2"];
    this.collectResponses(index);
    
    if (this.currentIndex == 1) {
      const inputField = document.querySelector('input[name="option_2"]');
      if (!inputField.value.trim()) {
        inputField.style.borderColor = "#ff5050";
        setTimeout(() => {
          inputField.style.borderColor = "";
        }, 600);
        return;
      }

      this.updateName(oldName);
    }


    console.log("nextSection", index, this.currentIndex , this.totalSteps - 1, this.currentIndex === this.totalSteps - 1);

    if (this.currentIndex < this.totalSteps - 1) {
      console.log("nextSection 1");
      this.updateHash(this.currentIndex + 1);
    } else if (this.currentIndex === this.totalSteps - 1) {
      console.log("nextSection 2");
      this.fetchResultsPage(() => this.updateHash(this.currentIndex + 1));
    }
  }

  prevSection() {
    if (this.currentIndex > 0) {
      this.updateHash(this.currentIndex - 1);
    } else {
      window.location.replace(window.location.origin);
    }
  }

  updateHash(index) {
    window.location.hash = `#step-${index}`;
  }

  weightInputSetup() {

    const container = this.querySelector("[data-weight]")?.closest(".element-section");
    if (!container) return;

    const nextButton = container.querySelector(".next-button");
    const weightInput = container.querySelector("[data-weight]");
    const inputGroup = container.querySelector(".input--group");

    nextButton.disabled = true;

    const errorContainer = document.createElement("div");
    Object.assign(errorContainer.style, {
      color: "red", fontSize: "14px", marginTop: "5px"
    });
    inputGroup.appendChild(errorContainer);

    const showError = msg => errorContainer.textContent = msg;
    const clearError = () => {
      errorContainer.textContent = "";
      weightInput.style.border = "";
    };

    // Set default unit
    Object.assign(weightInput, { placeholder: "KG" });
    inputGroup.dataset.units = "KG";

    // Pre-fill value if available
    if (this.responses[`option_${container.dataset.index}`]) {
      const weight = this.responses[`option_${container.dataset.index}`];
      Object.assign(weightInput, { value: weight });
    }
    
    const validateInputs = () => {
      const weight = weightInput.value.trim();
      nextButton.disabled = true;
      if (!weight) return showError("Laukas yra privalomas.");

      const errorMessage = this.validateWeight(null, weight, true); // Always metric
      if (errorMessage) {
        showError(errorMessage);
        if (errorMessage.includes("Weight")) weightInput.style.border = "1px solid red";
        return;
      }

      clearError();
      nextButton.disabled = false;
    };

    weightInput.addEventListener("input", validateInputs);
    validateInputs();
  }

  validateWeight(_, weight, isMetric) {
    if (!weight) {
      return "Weight must be filled.";
    }

    if (isMetric) {
      if (!/^\d+(\.\d+)?$/.test(weight)) {
        return "Weight must be a number.";
      }
      const weightNum = parseFloat(weight);
      if (weightNum < 1 || weightNum > 80) {
        return "Weight must be between 1 and 80 kg.";
      }
    }

    return null;
  }

  savedQuiz(action, name, url) {
    if(action === "save") {
      const savedQuiz = JSON.parse(localStorage.getItem("savedQuiz")) || {};
      console.log("savedQuiz", name);
      if(name) {
        savedQuiz[name] = url;
      } else {
        savedQuiz["Augintinis"] = url;
      }
      
      localStorage.setItem("savedQuiz", JSON.stringify(savedQuiz));
    } else {
      const savedQuizList = document.getElementById("savedQuiz");
      const savedQuiz = JSON.parse(localStorage.getItem("savedQuiz")) || {};

      // savedQuizList.innerHTML = "";

      for (const name in savedQuiz) {
        const url = savedQuiz[name];
        savedQuizList.classList.remove("hide");

        const li = document.createElement("li");
        li.classList.add("button", "button--primary");

        const a = document.createElement("a");
        a.href = url;
        a.textContent = name;

        const removeBtn = document.createElement("button");
        removeBtn.textContent = "";
        removeBtn.style.marginLeft = "5px";
        removeBtn.dataset.name = name; // store name in data attribute for reference

        li.appendChild(a);
        li.appendChild(removeBtn);
        savedQuizList.appendChild(li);
      }
    }

    
    this.delegateListener("click", "#savedQuiz button", (e) => {
      const btn = e.target;
      const name = btn.dataset.name;
      if (!name) return;

      // Remove from localStorage
      const savedQuiz = JSON.parse(localStorage.getItem("savedQuiz")) || {};
      delete savedQuiz[name];
      localStorage.setItem("savedQuiz", JSON.stringify(savedQuiz));

      // Remove the <li> element from DOM
      const li = btn.closest("li");
      if (li) li.remove();
    });
  }

  fetchResultsPage(callback) {
    let queryParams = new URLSearchParams();
    let urlResponses = this.getParamsFromUrl();


    this.backButton.dataset.hidden = Object.keys(urlResponses).length !== 0;
    // this.stepsWrapper.dataset.hidden = Object.keys(urlResponses).length !== 0;

    console.log("urlResponses", urlResponses);

    let storedResponses = JSON.parse(localStorage.getItem("quizResponsesFull")) || {};
    // this.responses = Object.keys(urlResponses).length > 0 ? urlResponses : storedResponses;
    this.responsesFull = Object.keys(urlResponses).length > 0 ? urlResponses : storedResponses;


    console.log(this.responsesFull);

    if(this.responsesFull["quiz"] != this.quizIndex) {
      localStorage.removeItem("quizResponses");
      localStorage.removeItem("quizResponsesFull");
      window.location.replace(location.href.match(/^https?:\/\/[^\/]+\/[^\/]+\/[^\/]+/)[0]);
      return;
    }
    
    // Object.keys(this.responses).forEach((key) => {
    //   let value = this.responses[key];
    //   queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
    // });
    Object.keys(this.responsesFull).forEach((key) => {
      let value = this.responsesFull[key].replaceAll("+", "plu5s").replaceAll("/", "sla5sh");
      queryParams.append(key, Array.isArray(value) ? value.join("+") : value);
    });

    document.body.style.overflow = "hidden";

    this.loadingOverlay.classList.remove("hide");

    this.savedQuiz("save", this.responses["option_2"], `${ (location.origin + window.Shopify.routes.root) }pages/quiz/${queryParams.toString()}`);

    fetch(`${ (location.origin + window.Shopify.routes.root) }pages/${ this.resultsPageHandle }/${queryParams.toString()}`)
      .then(response => response.text())
      .then(html => {
        let resultsContainer = this.querySelector("[data-results]");
        if (resultsContainer) resultsContainer.innerHTML = html;
        if (callback) callback();
        setTimeout(() => {
          this.loadingOverlay.classList.add("hide");
          document.body.style.overflow = "visible";

            document.querySelectorAll('#section--2 p').forEach(p => {
              if (p.innerHTML.trim() === '&nbsp;') {
                p.remove();
              }
            });

        }, 2500);
      })
      .catch(error => console.error("Error fetching results:", error));
  }
  
  setFormInputValues() {
    let quizData = this.responsesFull;
    const formSelector = '.section-email [id^="omnisend-form-"]';

    const replaceLithuanian = (str) => {
      return str
        .replaceAll("ą", "a").replaceAll("Ą", "A")
        .replaceAll("č", "c").replaceAll("Č", "C")
        .replaceAll("ę", "e").replaceAll("Ę", "E")
        .replaceAll("ė", "e").replaceAll("Ė", "E")
        .replaceAll("į", "i").replaceAll("Į", "I")
        .replaceAll("š", "s").replaceAll("Š", "S")
        .replaceAll("ų", "u").replaceAll("Ų", "U")
        .replaceAll("ū", "u").replaceAll("Ū", "U")
        .replaceAll("ž", "z").replaceAll("Ž", "Z").replaceAll(" ", "_");
    }

    const interval = setInterval(() => {
      const formContainer = document.querySelector(formSelector);
      const form = formContainer ? formContainer.querySelector('form') : null;

      if (!form) return;

      let successCount = 0;

      Object.entries(quizData).forEach(([ariaLabel, answer]) => {
        const input = form.querySelector(`[name="custom_${replaceLithuanian(ariaLabel)}"]`);
        if (input) {
          input.value = answer;
          input.dispatchEvent(new Event('input', { bubbles: true })); // ensures Omnisend sees the change
          successCount++;
        } else {
          console.warn(`⚠️ Input with aria-label "${ariaLabel}" not found`);
        }
      });

      if (successCount > 0) {
        console.log(`✅ ${successCount} quiz answers injected into Omnisend form.`);
      }

      clearInterval(interval);
    }, 300);
  }

  klaviyoForm() {
    const formContainer = document.querySelector('.section-email [id^="omnisend-embedded-"]');
    const nextButton = document.querySelector(".section-email .element-button .next-button");

    if (formContainer && nextButton) {
      nextButton.style.display = "none";
      let successHandled = false; // Prevent multiple triggers

      const observer = new MutationObserver((mutations, obs) => {
        if (successHandled) return; // Exit early if already done

        for (const mutation of mutations) {
          if (mutation.type === "attributes" && mutation.attributeName === "style") {
            const successMessage = formContainer.querySelector(
              '[class*="success-sections-container"]:not([style*="display: none"])'
            );
            const errorMessage = formContainer.querySelector(
              '[class*="subscribed-sections-container"]:not([style*="display: none"])'
            );

            if (successMessage || errorMessage) {
              successHandled = true;
              nextButton.style.display = "block";
              this.nextSection(formContainer.closest(".section-email").dataset.index);
              obs.disconnect();
              break;
            }
          }
        }
      });

      observer.observe(formContainer, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ["style"]
      });
    }
  }

  cartAdd(formData, _this) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((response) => response.json())
    .then(response => {
      fetch(window.Shopify.routes.root + "?sections=cart-icon-bubble")
        .then((response) => response.json())
        .then((response) => {
          let selector = "#cart-icon-bubble2";
          let drawer = document.querySelector(selector);
          drawer.innerHTML = new DOMParser().parseFromString(response["cart-icon-bubble"], 'text/html').querySelector("#shopify-section-cart-icon-bubble").innerHTML;
          document.querySelector(".element-headerSteps .cart-count-bubble").classList.remove("hide");
          _this.classList.remove("button--loading");
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  productCartButton(event) {
    let _this = event.target; 
    let id = _this.dataset.id; 
    let plan = _this.dataset.plan; 
    let productPrice = _this.dataset.price; 
    let items = {"id": id, "quantity": 1};
    let formData = {'items': [], "sections": "cart-data"};
    formData.items.push(items);
    _this.classList.add("button--loading");
    this.cartAdd(formData, _this);
  }


  cartAdd(formData, _this) {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(response => fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`))
    .then(response => response.json())
    .then(response => {
      const bubble = document.querySelector(".cart-count-bubble");
      bubble.innerHTML = new DOMParser().parseFromString(response["cart-icon-bubble"], 'text/html').querySelector(".cart-count-bubble").innerHTML;

      console.log(response);
      document.querySelector(".element-headerSteps .cart-count-bubble").classList.remove("hide");
      _this.classList.remove("style--buttonLoading");
      
    })
    .catch(console.error);
  }

  productCartButton(event) {
    let _this = event.target;
    let container = _this.closest(".element-products");
    let subscriptionCheckbox = document.querySelector(`[data-section="quiz_products"] #checkobx-subs`)?.checked;
    
    let { id, plan, price: productPrice, subscriptionPrice, qty } = _this.dataset;
    let items = { id, quantity: parseInt(qty) };
    let formData = { items: [] };
  
    if (plan && !subscriptionCheckbox) {
      productPrice = subscriptionPrice;
      items.selling_plan = plan;
  
      let { cartMessage, checkoutMessage } = container.dataset;
      if (cartMessage || checkoutMessage) {
        items.properties = {};
        if (cartMessage) items.properties[window.theme.cart_message] = cartMessage;
        if (checkoutMessage) items.properties[window.theme.checkout_message] = checkoutMessage;
      }
    }
  
    formData.items.push(items);
    
    _this.classList.add("style--buttonLoading");

    this.cartAdd(formData, _this);
  }
}

customElements.define("quiz-element", QuizElement);


class SelectElement extends HTMLElement {
  constructor() {
    super();
    this.select = null;
    this.input = null;
    this.dropdownContainer = null;
  }

  connectedCallback() {
    this.select = this.querySelector('select');
    this.input = this.querySelector('.search-input');
    this.dropdownContainer = this.querySelector('.select-drpdown--inner');

    this.renderDropdown();
    this.attachEventListeners();
    this.input.addEventListener('focus', () => {
      this.showDropdown(true);
      this.toggleActiveClass(true);
    });

    this.input.addEventListener('blur', () => {
      setTimeout(() => {
        this.showDropdown(false);
        this.toggleActiveClass(false);
      }, 200);
      
    });
  }

  attachEventListeners() {
    // Native select changes update custom dropdown
    this.select.addEventListener('change', () => this.highlightSelected());

    // Input filter
    this.input.addEventListener('input', () => this.filterOptions());

    // Mutation observer to watch for option changes
    const observer = new MutationObserver(() => this.renderDropdown());
    observer.observe(this.select, { childList: true, subtree: true });
  }

  toggleActiveClass(isActive) {
    const wrapper = this.querySelector('.select--inner');
    if (wrapper) {
      wrapper.classList.toggle('active', isActive);
    }
  }

  renderDropdown() {
    const options = Array.from(this.select.options);
    this.dropdownContainer.innerHTML = ''; // Clear current items

    options.forEach(option => {
      const item = document.createElement('div');
      item.className = 'dropdown-item';
      item.innerHTML = `<span data-value="${option.value}">${option.textContent}</span>`;

      item.addEventListener('click', () => {
        this.select.value = option.value;
        this.input.value = option.textContent;
        this.select.dispatchEvent(new Event('change'));
      });

      this.dropdownContainer.appendChild(item);
    });

    this.highlightSelected();
  }

  showDropdown(show) {
    const dropdown = this.querySelector('.select-drpdown--inner');
    if (dropdown) {
      dropdown.style.display = show ? 'block' : 'none';
    }
  }

  highlightSelected() {
    const selectedValue = this.select.value;
    const items = this.dropdownContainer.querySelectorAll('.dropdown-item span');

    items.forEach(item => {
      item.parentElement.classList.toggle('selected', item.dataset.value === selectedValue);
    });

    const selectedText = this.select.selectedOptions[0]?.textContent || '';
    this.input.value = selectedText;
  }

  filterOptions() {
    const query = this.input.value.toLowerCase();
    const items = this.dropdownContainer.querySelectorAll('.dropdown-item');

    items.forEach(item => {
      const text = item.textContent.toLowerCase();
      item.style.display = text.includes(query) ? '' : 'none';
    });
  }
}

customElements.define('select-element', SelectElement);